import React, { useEffect, useState, useRef } from "react";
import logo from '../../images/logo.png';
import users from '../../images/user.png';
import { Link } from "react-router-dom";
import axios from "axios";
import URL from "../config/API";

function HeaderPart({ getValue, setIsActiveCart, getCart, getTotal , setKeword }) {
    const [cartNumber, setCartNumber] = useState();
    const [token] = useState(localStorage.getItem("token"));
    const [searchText, setSearchText] = useState("");

    // 🔽 PROFILE DROPDOWN STATE
    const [openProfile, setOpenProfile] = useState(false);
    const profileRef = useRef(null);

    const showTheCart = () => {
        setIsActiveCart(true);
    };

    const getCartCounts = () => {
        axios.post(`${URL.BASE_URL}/cart-counts`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        }).then(res => {
            setCartNumber(res?.data?.data);
        });
    };

    useEffect(() => {
        getCartCounts();
    }, [getCart]);

    // 🔒 CLOSE DROPDOWN ON OUTSIDE CLICK
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setOpenProfile(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


const searchHandler = (e) =>{

    setKeword(e.target.value)
}



    return (
        <>
            <header className="header-part">
                <div className="container">
                    <div className="header-content">

                        <div className="header-media-group">
                            <button className="header-user">
                                <img src={logo} alt="user" />
                            </button>
                            <Link to='/'><img src={logo} alt="logo" /></Link>
                            <button className="header-src">
                                <i className="fas fa-search"></i>
                            </button>
                        </div>

                        <Link className="header-logo" to='/'>
                            <img src={logo} alt="logo" />
                        </Link>

                        {/* 🔽 PROFILE DROPDOWN */}
                        <div className="header-widget profile-dropdown" ref={profileRef}>
                            <button
                                className="profile-trigger"
                                type="button"
                                onClick={() => setOpenProfile(!openProfile)}
                            >
                                <img src={users} alt="user" />
                                <span>Profile</span>
                            </button>

                            {openProfile && (
                                <ul className="profile-menu">
                                    <li><Link to="/wallet">Wallet</Link></li>
                                    <li><Link to="/update-profile">Update Profile</Link></li>
                                    <li><Link to="/change-password">Change Password</Link></li>

                                    <li className="submenu">
                                        <span>Share</span>
                                        <ul>
                                            <li>
                                                <a href="https://wa.me/?text=Check%20this%20app" target="_blank" rel="noreferrer">
                                                    WhatsApp
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.facebook.com/sharer/sharer.php?u=https://yourwebsite.com" target="_blank" rel="noreferrer">
                                                    Facebook
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                                                    Instagram
                                                </a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li><Link to="/generate-email">Generate Email</Link></li>

                                    <li
                                        className="logout"
                                        onClick={() => {
                                            localStorage.clear();
                                            window.location.href = "/login";
                                        }}
                                    >
                                        Logout
                                    </li>
                                </ul>
                            )}
                        </div>

                        {/* SEARCH */}
                        <form
                            className="header-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (searchText.trim()) {
                                    window.location.href = `/products?search=${searchText}`;
                                }
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Search anything..."
                                name ="searchText"
                                onKeyUp={ searchHandler}
                            />
                            <button type="submit">
                                <i className="fas fa-search"></i>
                            </button>
                        </form>


                        {/* CART & WISHLIST */}
                        <div className="header-widget-group">
                            <Link className="header-widget" to='/wishlist' title='Wishlist'>
                                <i className="fas fa-heart"></i>
                                <sup>{getValue}</sup>
                            </Link>

                            <button
                                className="header-widget header-cart"
                                title="Cartlist"
                                onClick={showTheCart}
                            >
                                <i className="fas fa-shopping-basket"></i>
                                <sup>{cartNumber}</sup>
                                <span>total price <small>${getTotal}</small></span>
                            </button>
                        </div>

                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderPart;
